import { mapGetters } from 'vuex'
import { isAndroid, isIos } from '@/helpers/device'

export default {
	computed: {
		...mapGetters({
			language: 'i18n/getLanguage',
			accountPlatform: 'location/accountPlatform',
			getQueryParam: 'location/getQueryParam',
			userBmi: 'getBmi',
			countryCode: 'getCountryCode',
			regionCode: 'getRegionCode',
			getPropertyValue: 'survey/getPropertyValue',
			appTheme: 'getAppTheme',
			isOrganicTrafficOnboarding: 'userFlags/getIsOrganicTrafficOnboarding',
			FEAT_CONFIRM_EMAIL_BY_CODE: 'coreFeatures/FEAT_CONFIRM_EMAIL_BY_CODE',
			subscriptionProvider: 'subs/checkProvider',
			subscriptionPeriodType: 'subs/checkPeriodType',
			canDowngradeSubscription: 'subs/canDowngrade',
			lastUsedProvider: 'paywall/getLastUsedProvider',
			subscription: 'subs/getSubscription',
			userGeo: 'getGeo',
		}),
		IS_OPTIMIZE_POST_PURCHASE_FLOW_EXP() {
			return this.$absmartly.treatment('web_optimize_post_purchase_flow')
		},
		IS_SIMPLE_WEB_APP_MVP_EXP() {
			return this.$absmartly.treatment('web_simple_mvp_launch')
		},
		IS_ACCOUNT_DELETION_DEEPLINK_EXP() {
			return this.getQueryParam('exp') === 'ios_improve_account_deletion'
		},
		IS_ACCOUNT_DELETION_DEEPLINK_V2_EXP() {
			return this.getQueryParam('exp') === 'ios_improve_account_deletion_v2'
		},
		IS_ANDROID_ACCOUNT_DELETION_DEEPLINK_EXP() {
			return this.getQueryParam('exp') === 'android_improve_account_deletion'
		},
		IS_AUTH0_ACCOUNT_DELETION_DEEPLINK_ACCOUNT_DELETION() {
			return this.getQueryParam('exp') === 'auth0_rollout_deletion'
		},
		IS_CONFIRM_EMAIL_BY_CODE_EXP() {
			return (this.accountPlatform.ios || this.accountPlatform.android) && this.FEAT_CONFIRM_EMAIL_BY_CODE
		},
		IS_CLICK_TO_CANCEL_CALIFORNIA() {
			return this.regionCode?.toLowerCase?.() === 'ca'
		},
		IS_CANCELLATION_NEGATIVITY_REDUCTION() {
			return this.accountPlatform.android && this.$absmartly.treatment('web_cancellation_negativity_reduction')
		},
		IS_DLOCAL_ACQUIRING_IN_BR_AND_MX_EXP() {
			return ['mx'].includes(this.countryCode) && this.$absmartly.treatment('web_dlocal_acquiring_in_mx')
		},
		IS_FEMALE_WALKING_OPTIMIZATION_EXP() {
			return this.AREA.WALKING_FEMALE && this.language === 'en'
		},
		IS_ONE_PREDICT_INSTEAD_OF_MANY_EXP() {
			return this.$absmartly.treatment('web_one_predict_instead_of_many')
		},
		IS_PALTA_GOOGLE_PAY_EXP() {
			return isAndroid && this.$absmartly.treatment('web_palta_google_pay')
		},
		IS_OFFERING_TRIAL_WITH_COMMITMENTS_I3_MALE_EXP() {
			return this.AREA.BAU_MALE && this.$absmartly.treatment('web_offering_trial_with_commitments_i3_male')
		},
		IS_WHEEL_OF_FORTUNE_MALE_EXP() {
			return this.AREA.BAU_MALE && this.$absmartly.treatment('web_wheel_of_fortune_male')
		},
		IS_WHEEL_OF_FORTUNE_FEMALE_ACTIVITY_EXP() {
			return this.AREA.ACTIVITY_FEMALE && this.$absmartly.treatment('web_wheel_of_fortune_activity_female')
		},
		IS_WHEEL_OF_FORTUNE_WALKING_FEMALE_EXP() {
			return this.AREA.WALKING_FEMALE && this.$absmartly.treatment('web_wheel_of_fortune_walking_female')
		},
		IS_WHEEL_OF_FORTUNE_YOGA_FEMALE_EXP() {
			return this.AREA.YOGA && this.$absmartly.treatment('web_wheel_of_fortune_yoga_female')
		},
		IS_WEB_SUMMARY_CHECKPOINTS_WALKING() {
			return this.$absmartly.treatment('web_summary_checkpoints_walking')
		},
		IS_WEB_SUMMARY_CHECKPOINTS_YOGA() {
			return this.$absmartly.treatment('web_summary_checkpoints_yoga')
		},
		IS_DEEP_LINKS_TAI_CHI_EXP() {
			return isIos && this.$absmartly.treatment('web_deep_links_tai_chi')
		},
		IS_WHEEL_OF_FORTUNE_FEMALE_FASTING_EXP() {
			// iteration 3
			return this.$absmartly.treatment('web_wheel_of_fortune_female')
		},
		IS_WARMUP_BEFORE_WINBACK_OFFER_EXP() {
			return !this.subscriptionPeriodType.isCommitment && this.$absmartly.treatment('web_warmup_before_winback_offer')
		},
		IS_QUESTION_FOR_CEO_EXP() {
			// чтоб было удобно удалять потом геттер
			return this.countryCode === 'us'
		},
		IS_NEW_APP_DOWNLOAD_SCREEN_EXP() {
			return this.$absmartly.treatment('web_new_app_download_screen')
		},
		IS_PARTIAL_RETRIES_FOR_UPSALES_EXP() {
			return this.subscriptionProvider.isPalta && this.$absmartly.treatment('web_partial_retries_for_upsales')
		},
		IS_COMMITMENT_CANCELLATION_DYNAMIC_EXP_B() {
			// /result_complete?safe=true&host=simple.life&country=US&lang=en&utm_source=dashboard&area=activity-female-pilates&mock-data=true&exp=web_commitment_cancellation_dynamic~1&exp=web_simple_billing_vs_palta~1
			return (
				this.subscriptionPeriodType.isCommitment &&
				this.$absmartly.treatment('web_commitment_cancellation_dynamic') === 1
			)
		},
		IS_COMMITMENT_CANCELLATION_DYNAMIC_EXP_C() {
			// /result_complete?safe=true&host=simple.life&country=US&lang=en&utm_source=dashboard&area=activity-female-pilates&mock-data=true&exp=web_commitment_cancellation_dynamic~2&exp=web_simple_billing_vs_palta~1
			return (
				this.subscriptionPeriodType.isCommitment &&
				this.$absmartly.treatment('web_commitment_cancellation_dynamic') === 2
			)
		},
		IS_TRANSACTION_DELAY_FOR_ONE_CLICK_EXP() {
			return this.$absmartly.treatment('web_transaction_delay_for_one_click')
		},
		IS_EMAIL_DELAY_3MIN_EXP() {
			return this.$absmartly.treatment('web_email_delay_3min')
		},
		IS_FEMALE_RISK_FREE_OFFER_EXP() {
			return this.$absmartly.treatment('web_female_risk_free_offer')
		},
		IS_PHONE_NUMBERS_ON_THE_CONFIRMATION_SCREEN_EXP() {
			return this.$absmartly.treatment('web_phone_numbers_on_the_confirmation_screen')
		},
		IS_WALKING_GS_SCROLLING_URGENCY_MESSAGE_EXP() {
			return this.$absmartly.treatment('web_walking_gs_scrolling_urgency_message')
		},
		IS_BUY_6_GET_12_PILATES_EXP() {
			return this.AREA.PILATES_FEMALE && this.$absmartly.treatment('web_buy_6_get_12_pilates')
		},
		IS_PRICING_ON_FASTING_FUNNELS_WITH_SP_EXP() {
			return this.$absmartly.treatment('web_pricing_on_fasting_funnels_with_sp_nonus')
		},
		IS_PRICING_ON_PILATES_FUNNEL_WITH_SP_EXP() {
			return this.$absmartly.treatment('web_pricing_on_pilates_funnel_with_sp')
		},
		IS_WALKING_FEMALE_RISK_FREE_OFFER_EXP() {
			return this.$absmartly.treatment('web_walking_female_risk_free_offer')
		},
		IS_TRANSACTION_UX_DECLINES_IMPROVEMENT_EXP() {
			return this.$absmartly.treatment('web_transaction_ux_declines_improvement')
		},
		IS_ONE_PREDICT_INSTEAD_OF_TWO_WALKING_MALE_EXP() {
			return this.$absmartly.treatment('web_walking_male_one_predict_instead_of_two')
		},
		IS_PILATES_FEMALE_PROGRESS_TEASER_EXP() {
			return this.$absmartly.treatment('web_pilates_female_progress_teaser')
		},
		IS_TAI_CHI_FEMALE_PROGRESS_TEASER_EXP() {
			return this.$absmartly.treatment('web_tai_chi_female_al_progress_teaser')
		},
		IS_WALKING_FEMALE_PROGRESS_TEASER_EXP() {
			return this.$absmartly.treatment('web_walking_female_progress_teaser')
		},
		IS_TAI_CHI_MALE_PROGRESS_TEASER_EXP() {
			return this.$absmartly.treatment('web_tai_chi_male_progress_teaser')
		},
		IS_SCONE_ADAPTED_COPY_GB_EXP_B() {
			return this.$absmartly.treatment('web_scone_adapted_copy_gb') === 1
		},
		IS_SCONE_ADAPTED_COPY_GB_EXP_C() {
			return this.$absmartly.treatment('web_scone_adapted_copy_gb') === 2
		},
		IS_BULK_CHANGES_WALKING_FEMALE_EXP() {
			return this.$absmartly.treatment('web_bulk_change_walking_female')
		},
		IS_MALE_FASTING_RISK_FREE_OFFER_EXP() {
			return this.$absmartly.treatment('web_male_fasting_risk_free_offer')
		},
		IS_APPLE_PAY_CIT_E_COMMERCE_AUTH_EXP() {
			return this.$absmartly.treatment('web_apple_pay_cit_e_commerce_auth')
		},
		IS_PRIMER_GOOGLE_PAY_EXP() {
			return isAndroid && this.$absmartly.treatment('web_primer_google_pay')
		},
		IS_SHORT_PLAN_DOWNGRADE_EXP() {
			return this.canDowngradeSubscription && this.$absmartly.treatment('web_short_plan_downgrade')
		},
		IS_PILETS_PLAN_PREVIEW_BEFORE_PAYWALL_EXP() {
			return this.$absmartly.treatment('web_pilates_plan_preview_before_paywall')
		},
		IS_EMAIL_SUGGEST_EXP() {
			return this.$absmartly.treatment('web_email_suggest')
		},
		IS_FASTING_F_START_DATE_ON_WELCOME_EXP_B() {
			return this.$absmartly.treatment('web_fasting_fem_start_date_and_people_on_welcome') === 1
		},
		IS_FASTING_F_START_DATE_ON_WELCOME_EXP_C() {
			return this.$absmartly.treatment('web_fasting_fem_start_date_and_people_on_welcome') === 2
		},
		IS_LOGIN_MENU_EMAIL_CAPTURE_EXP() {
			return this.$absmartly.treatment('web_login_menu_email_capture')
		},
		IS_PIX_PAYMENT_METHOD_FOR_BR_EXP() {
			if (this.subscription?.payment_method === 'pix_automatico') {
				return true
			}
			return this.$absmartly.treatment('web_pix_payment_method_for_br')
		},
		IS_DATA_INPUT_SCREENS_OPTIMIZED_EXP() {
			return this.$absmartly.treatment('web_data_input_screens_optimized')
		},
		IS_FASTING_F_LOADER_BEFORE_EMAIL_EXP() {
			return this.$absmartly.treatment('web_fasting_fem_loader_before_email')
		},
		IS_SALES_TAX_EXCLUSION_CHAIR_WORKOUTS_EXP() {
			const hasUserGeo = Boolean(this.userGeo?.zip && this.userGeo?.city && this.userGeo?.region)

			return hasUserGeo && this.$absmartly.treatment('web_chair_workouts_male_sales_tax_exclusion_i2')
		},
		IS_FASTING_F_SOCIAL_PROOF_ON_FIRST_AND_PAYWALL_EXP() {
			return this.$absmartly.treatment('web_fasting_fem_social_proof_on_first_and_paywall')
		},
		IS_TAI_CHI_AL_FREE_GUIDE_EXP() {
			return this.$absmartly.treatment('web_tai_chi_al_free_guide')
		},
		IS_CHAIR_WORKOUTS_MALE_LOADER_TEASER_EXP() {
			return this.$absmartly.treatment('web_chair_workouts_male_loader_teaser')
		},
	},
}
